import { addGoods, allGoods, deleteGoods, updateGoods } from '@/utils/request'
import vue from '@/main'

const state = {
  goodsList: []
}

const mutations = {
  RESET (state) {
    state.goodsList = []
  }
}

const actions = {
  all ({ state }) {
    return new Promise((resolve) => {
      allGoods().then(response => {
        state.goodsList = response.data
        resolve(state.goodsList)
      })
    })
  },
  goodsById ({ commit, state }, id) {
    for (const team of state.goodsList) {
      if (team.id === id) return vue.$_.cloneDeep(team)
    }
    return null
  },
  updateOne ({ state }, goods) {
    return new Promise((resolve) => {
      updateGoods(goods).then(() => {
        for (const cur of state.goodsList) {
          if (cur.id === goods.id) {
            Object.assign(cur, goods)
            break
          }
        }
        resolve()
      })
    })
  },
  add ({ commit, dispatch, state }, team) {
    return new Promise((resolve) => {
      addGoods(team).then((response) => {
        state.goodsList.push(response.data)
        resolve(response.data)
      })
    })
  },
  delete ({ commit, dispatch, state }, id) {
    return new Promise((resolve) => {
      deleteGoods(id).then(() => {
        for (const i in state.goodsList) {
          if (state.goodsList[i].id === id) {
            state.goodsList.splice(i, 1)
          }
        }
        resolve()
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
